export function devMode(dev, assetsObject, currentSetCookies) {
	if (dev) {
		console.log('DEV MODE IS ACTIVE.');
		console.log('ASSETS OBJECT', assetsObject);
		console.log('CURRENT SET COOKIES', currentSetCookies);
	}
}

export function dlog(dev, message, title = 'DEV') {
	if (dev) {
		console.log(title, message);
	}
}
